import template from './insuranceCustomerCare.html';
import InsuranceCustomerCareCtrl from './insuranceCustomerCareCtrl';

export default {
  template,
  controller: InsuranceCustomerCareCtrl,
  controllerAs: 'vm',
};
